import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isToday from 'date-fns/is_today';
import isFuture from 'date-fns/is_future';
import isYesterday from 'date-fns/is_yesterday';
import isThisWeek from 'date-fns/is_this_week';
import isThisMonth from 'date-fns/is_this_month';
import startOfYesterday from 'date-fns/start_of_yesterday';
import endOfWeek from 'date-fns/end_of_week';
import startOfWeek from 'date-fns/start_of_week';
import en from 'date-fns/locale/en';
import ru from 'date-fns/locale/ru';
import format from 'date-fns/format';
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';

import { formatDateTime } from 'rebook/apps/utils/datetime';
import DashboardBookListEmpty from 'rebook/apps/dashboard/components/DashboardBookListEmpty';
import Button from 'rebook/apps/base/components/Button';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';

import DashboardSectionByDate from './DashboardSectionByDate';
import styles from './style.scss';


class DashboardView extends React.Component {
  constructor(props) {
    super(props);
    const { booksPerSubscriptionCounter } = props;
    this.fetchPageMutex = false;
    this.state = {
      loading: true,
      nextPageQuery: {},
      isNextPageDisabled: true,
      otherMonthsKeys: [],
      future: [],
      today: [],
      yesterday: [],
      thisWeek: [],
      thisMonth: [],
      otherMonths: {},
    };

    if (get(props, 'dashboardBlockList.dashboardState', false)) {
      this.state = { ...this.state, ...props.dashboardBlockList.dashboardState };
    }

    this.title = 'Что почитать интересного? Подборки, которые помогут вам определиться, какую книгу почитать';
    this.description = `В электронной библиотеке MyBook можно прочитать ` +
                      `и послушать более ${booksPerSubscriptionCounter.total} ` +
                      `электронных книг и аудиокниг. Для онлайн чтения доступны ` +
                      `шедевры современной и классической литературы. ` +
                      `Новинки и бестселлеры, отзывы, рекомендации, популярные авторы.`;

    this.props.SeoActions.setData({
      title: this.title,
      description: this.description,
    });
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchNextPage();
  }

  updateBlocksList(objects) {
    const { dashboardBlockList } = this.props;
    const stateCopy = this.state;

    if (!objects) {
      this.props.DashboardBlockListActions.setDashboardState(stateCopy);
      return stateCopy;
    }

    objects.map((object, i) => {
      const pubDate = get(object, 'publish_date', '');
      const key = `${object.id}-${object.type}`;
      const isExist = !!dashboardBlockList[key];

      if (isExist) {
        this.props.DashboardBlockListActions.setDashboardState(stateCopy);
        return stateCopy;
      }

      if ((isFuture(pubDate) || !pubDate)) {
        stateCopy.future.push({ ...object, key: `${i}` });
      }
      else if (isToday(pubDate)) {
        stateCopy.today.push({ ...object, key: `${i}` });
      }
      else if (isYesterday(pubDate)) {
        stateCopy.yesterday.push({ ...object, key: `${i}` });
      }
      else if (isThisWeek(pubDate, { weekStartsOn: 1 })) {
        stateCopy.thisWeek.push({ ...object, key: `${i}` });
      }
      else if (isThisMonth(pubDate)) {
        stateCopy.thisMonth.push({ ...object, key: `${i}` });
      }
      else {
        const dateKey = format(pubDate, 'MMMMYY', { locale: en });
        if (!stateCopy[dateKey]) {
          stateCopy[dateKey] = [];
          stateCopy.otherMonthsKeys.push(dateKey);
        }
        stateCopy[dateKey].push({ ...object, key: `${i}` });
      }
    });
    this.props.DashboardBlockListActions.setDashboardState(stateCopy);
    return stateCopy;
  }

  setFetchMutex() {
    if (this.fetchPageMutex) {
      return false;
    }
    this.fetchPageMutex = true;
    this.setState({ isNextPageDisabled: true });
    return true;
  }

  parseNextPageQuery(pageUrl) {
    if (!pageUrl) {
      return null;
    }
    const paramsString = pageUrl.split('?', 2)[1];
    return queryString.parse(paramsString);
  }

  fetchNextPage(loadNext = false) {
    const { match } = this.props;
    const { nextPageQuery } = this.state;
    if (!this.setFetchMutex()) {
      Raven.captureMessage('another fetch request is in progress', {
        level: 'warning',
      });
      return null;
    }

    if (get(this.props.dashboardBlockList, 'dashboardBlocks.objects', false) && !loadNext) {
      const { dashboardBlocks } = this.props.dashboardBlockList;
      this.fetchPageMutex = false;
      this.setState({
        ...this.updateBlocksList(dashboardBlocks.objects),
        nextPageQuery: this.parseNextPageQuery(dashboardBlocks.meta.next),
        isNextPageDisabled: false,
        loading: false,
      });
      return null;
    }
    this.props.DashboardBlockListActions.fetchInitialData(match, queryString.stringify(nextPageQuery))
      .then(() => {
        const { dashboardBlocks } = this.props.dashboardBlockList;
        this.setState({
          ...this.updateBlocksList(dashboardBlocks.objects),
          nextPageQuery: this.parseNextPageQuery(dashboardBlocks.meta.next),
          isNextPageDisabled: false,
          loading: false,
        });
        this.fetchPageMutex = false;
      })
      .catch(() => {
        this.fetchPageMutex = false;

        this.setState({
          isNextPageDisabled: false,
          loading: false,
        });
      });
  }

  render() {
    const { user } = this.props;
    const {
      loading, future, today,
      yesterday, thisWeek, thisMonth,
      otherMonthsKeys, nextPageQuery, isNextPageDisabled,
    } = this.state;

    return (
      <div className="backgroundContainer themeGrey">
        <div className="section">
          <h1>Что читать</h1>

          {loading
            ? <DashboardBookListEmpty />
            : (
              <React.Fragment>
                <DashboardSectionByDate
                  blocks={future}
                  user={user} />

                <DashboardSectionByDate
                  blocks={today}
                  user={user}
                  title={'Сегодня'}
                  subtitle={format(new Date(), 'dddd, D MMMM', { locale: ru })} />

                <DashboardSectionByDate
                  blocks={yesterday}
                  user={user}
                  title={'Вчера'}
                  subtitle={format(new Date(startOfYesterday()), 'dddd, D MMMM', { locale: ru })} />

                <DashboardSectionByDate
                  blocks={thisWeek}
                  user={user}
                  title={'На этой неделе'}
                  subtitle={`
                    ${format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'D MMMM', { locale: ru }) }
                    - ${format(endOfWeek(new Date(), { weekStartsOn: 1 }), 'D MMMM', { locale: ru })}
                  `} />

                <DashboardSectionByDate
                  blocks={thisMonth}
                  user={user}
                  title={'В этом месяце'}
                  subtitle={format(new Date(), 'MMMM YYYY', { locale: ru })} />

                {otherMonthsKeys.length > 0 && (
                  otherMonthsKeys.map((month) => (
                    <DashboardSectionByDate
                      blocks={this.state[month]}
                      user={user}
                      title={capitalize(format(
                        formatDateTime(this.state[month][0].publish_date),
                        'MMMM YYYY',
                        { locale: ru },
                      ))}
                      key={month} />
                  ))
                )}

                {(nextPageQuery !== null && !isNextPageDisabled) && (
                  <div className={styles.button}>
                    <Button
                      extraClassName="jest-dashboard-load-more"
                      isDisabled={isNextPageDisabled}
                      handleClick={() => this.fetchNextPage(true)}
                      theme="secondary">
                      Показать еще
                    </Button>
                  </div>
                )}
              </React.Fragment>
            )
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
    dashboardBlockList: state.dashboardBlockList,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardView);
